const countriesAmerica = [
  { name: 'Argentina', country_code: 'AR' },
  { name: 'Bolivia', country_code: 'BO' },
  { name: 'Brasil', country_code: 'BR' },
  { name: 'Canadá', country_code: 'CA' },
  { name: 'Chile', country_code: 'CL' },
  { name: 'Colombia', country_code: 'CO' },
  { name: 'Costa Rica', country_code: 'CR' },
  { name: 'Cuba', country_code: 'CU' },
  { name: 'República Dominicana', country_code: 'DO' },
  { name: 'Ecuador', country_code: 'EC' },
  { name: 'El Salvador', country_code: 'SV' },
  { name: 'Guayana Francesa', country_code: 'GF' },
  { name: 'Guatemala', country_code: 'GT' },
  { name: 'Guyana', country_code: 'GY' },
  { name: 'Honduras', country_code: 'HN' },
  { name: 'Haití', country_code: 'HT' },
  { name: 'Jamaica', country_code: 'JM' },
  { name: 'México', country_code: 'MX' },
  { name: 'Nicaragua', country_code: 'NI' },
  { name: 'Panamá', country_code: 'PA' },
  { name: 'Paraguay', country_code: 'PY' },
  { name: 'Perú', country_code: 'PE' },
  { name: 'Surinam', country_code: 'SR' },
  { name: 'Trinidad y Tobago', country_code: 'TT' },
  { name: 'Estados Unidos', country_code: 'US' },
  { name: 'Uruguay', country_code: 'UY' },
  { name: 'Venezuela', country_code: 'VE' }
]

export const salesData = [
  { country: 'Argentina', Q1: 132555, Q2: 137464, Q3: 299322, Q4: 330660 },
  { country: 'Brasil', Q1: 4419, Q2: 4582, Q3: 9978, Q4: 11022 },
  { country: 'Costa Rica', Q1: 34464, Q2: 35741, Q3: 77823, Q4: 85972 },
  { country: 'El Salvador', Q1: 15906, Q2: 16495.68, Q3: 35918.64, Q4: 39679.2 },
  { country: 'Guatemala', Q1: 34464, Q2: 35741, Q3: 77823.72, Q4: 85971.6 },
  { country: 'Honduras', Q1: 15907, Q2: 16496, Q3: 35918.64, Q4: 39679.2 },
  { country: 'Panamá', Q1: 15907, Q2: 16496, Q3: 35918.64, Q4: 39679.2 },
  { country: 'Puerto Rico', Q1: 7953, Q2: 8248, Q3: 17959.32, Q4: 19839 },
  { country: 'República Dominicana', Q1: 7953, Q2: 8248, Q3: 17959.32, Q4: 19839 },
  { country: 'Chile', Q1: 88370, Q2: 91643, Q3: 199548, Q4: 220440 },
  { country: 'Colombia', Q1: 327010, Q2: 339122, Q3: 738424, Q4: 815732 },
  { country: 'Ecuador', Q1: 4419, Q2: 4582, Q3: 9978, Q4: 11022 },
  { country: 'Estados Unidos', Q1: 14729, Q2: 15274, Q3: 33258, Q4: 36740 },
  { country: 'México', Q1: 117826, Q2: 122191, Q3: 266064, Q4: 293919 },
  { country: 'Perú', Q1: 44185, Q2: 45821, Q3: 99774, Q4: 110220 },
  { country: 'Uruguay', Q1: 7364, Q2: 7637, Q3: 16629, Q4: 18360 }
]

export const getCountryCode = (name) => {
  const country = countriesAmerica.find((country) => country.name === name)

  if (country) {
    return country.country_code
  }

  return '-'
}

export const getQSalesPercentByCountry = ({country, q, sum}) => {
  const sales = salesData.find((sale) => sale.country === country)
  const cleanValue = sum.replace(/[^0-9.]/g, '')

  const numericValue = parseFloat(cleanValue.replace(/,/g, ''))

  if (sales) {
    const qSales = sales[`Q${q}`]
    const percent = (numericValue / qSales) * 100
    return `${percent.toFixed(2)}%`
  }

  return '-'
  
}
